import React, { lazy, Suspense } from "react";
import ReactDOM from 'react-dom';
import {createFragmentContainer, QueryRenderer} from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import withStyles from "@material-ui/core/styles/withStyles";

import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';

import Button from '../../StorybookComponents/Button';
import Typography from '../../StorybookComponents/Typography';

import TopNav from '../../StorybookComponents/TopNav';
import Loader from '../Loader';
import ErrorPage from '../ErrorPage';
import withTheme, {theme} from '../../themes/app_theme';

import {
  Route,
  Link,
  Redirect,
  Switch
} from "react-router-dom";

const Accounts = lazy(() => import("../../pages/Accounts"));


export function renderWithPermissions(Component, props, authorised) {
  if (authorised) {
    return <Component {...props} />
  }
  else {
    return <Redirect
              to = {{
                pathname: '/access-denied',
                state: { from: props.location }
              }}
           />
  }
}

export default React.memo(({ pathname, toggleDrawer, authorization, classes }) => {

  const get_pathnames = path => {
    switch(path) {
      case '/': return 'Properties';
      case '/access-denied': return 'Access Deined';
      default:
        return path.replace(path[1], path[1].toUpperCase()).slice(1);//handle_access(path, authorization)
    }
  }
  return (
      <TopNav
         pathnames = {get_pathnames(pathname)}
         toggleDrawer = {toggleDrawer}
      >
          <Suspense fallback={<Loader />}>
            <Switch>
              <Route
                path="/accounts"
                render = {props => renderWithPermissions(Accounts, props, authorization.accounts)}
              />
              <Route path="/access-denied">
                <ErrorPage code = {401}/>
              </Route>
            </Switch>
          </Suspense>
      </TopNav>
  )
})
